module.exports = __webpack_public_path__ + "img/agentextension.54aeed44.png";